<mat-card class="example-card">
  <mat-card-header class="card-header">
    <mat-card-title class="card-titulo">Financiación de {{'MovimientoDeuda' | translate}}</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content style="margin-bottom: 0%;">

    <mat-label class="text-style" *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label class="text-style" *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label class="text-style" *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <ng-container *ngIf="canEdit">

      <!--SELECCION DE DEUDAS A FINANCIAR-->
      <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

        <mat-expansion-panel-header>
          <mat-panel-title class="card-subtitulo">
            <mat-icon style="margin-top: -3px;">playlist_add_check</mat-icon> Deudas a Financiar
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <!--BUSCADOR DE DEUDAS-->
        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

          <div fxFlex=100 fxFlex.xs=100 class="flex-item">

            <mat-expansion-panel *ngIf="!isMovimientoDeudaSearching">

              <mat-expansion-panel-header style="background-color: #ffd000BB;">
                <mat-panel-title>
                  <mat-icon style="margin-top: -3px;">search</mat-icon> ¿Queres refinar la búsqueda de las deudas?
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <form [formGroup]="searchDeudaForm">

                <div fxLayout="row stretch" fxLayout.xs="column">

                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label class="text-style" *ngIf="!isMonedaSearching">Moneda</mat-label>
                      <mat-label class="text-style" *ngIf="isMonedaSearching">Cargando...</mat-label>
                      <mat-select class="text-style" formControlName="MonedaId">
                        <mat-option class="text-style">Todas</mat-option>
                        <mat-option class="text-style" *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%" >
                      <mat-label class="text-style">Fecha Movimiento Desde</mat-label>
                      <input class="text-style" matInput [matDatepicker]="fechaMovimientoDesdePicker" formControlName="FechaMovimientoDesde"  (click)="fechaMovimientoDesdePicker.open()">
                      <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoDesdePicker">
                      </mat-datepicker-toggle>
                      <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDeudaDate('FechaMovimientoDesde')">
                        <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #fechaMovimientoDesdePicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label class="text-style">Fecha Movimiento Hasta</mat-label>
                      <input class="text-style" matInput [matDatepicker]="fechaMovimientoHastaPicker" formControlName="FechaMovimientoHasta"  (click)="fechaMovimientoHastaPicker.open()">
                      <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoHastaPicker">
                      </mat-datepicker-toggle>
                      <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDeudaDate('FechaMovimientoHasta')">
                        <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #fechaMovimientoHastaPicker></mat-datepicker>
                    </mat-form-field>
                  </div>

                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Detalle</mat-label>
                      <input matInput formControlName="Detalle" (keyup.enter)="searchGastosPendientes()">
                      <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                  </div>
                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%" >
                      <mat-label class="text-style">Fecha Vencimiento Desde</mat-label>
                      <input class="text-style" matInput [matDatepicker]="fechaVencimientoDesdePicker" formControlName="FechaVencimientoDesde"  (click)="fechaVencimientoDesdePicker.open()">
                      <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoDesdePicker">
                      </mat-datepicker-toggle>
                      <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDeudaDate('FechaVencimientoDesde')">
                        <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #fechaVencimientoDesdePicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label class="text-style">Fecha Vencimiento Hasta</mat-label>
                      <input class="text-style" matInput [matDatepicker]="fechaVencimientoHastaPicker" formControlName="FechaVencimientoHasta"  (click)="fechaVencimientoHastaPicker.open()">
                      <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoHastaPicker">
                      </mat-datepicker-toggle>
                      <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDeudaDate('FechaVencimientoHasta')">
                        <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #fechaVencimientoHastaPicker></mat-datepicker>
                    </mat-form-field>
                  </div>

                  <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlPedidos || tenantFeatureFlags?.HabilitarControlContratos">

                    <hr width="100%" style="margin: 5px 0px;">

                    <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlPedidos">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Nro. Pedido</mat-label>
                        <input matInput formControlName="PedidoId" type="number" (keyup.enter)="onSearch()">
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlContratos">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Cód. Contrato</mat-label>
                        <input matInput formControlName="Contrato" (keyup.enter)="onSearch()">
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </div>

                  </ng-container>

                  <hr width="100%" style="margin: 5px 0px;">

                  <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label *ngIf="!isConsorcioSearching">{{'Consorcio' | translate}}</mat-label>
                      <mat-label *ngIf="isConsorcioSearching">Cargando...</mat-label>
                      <mat-select formControlName="ConsorcioId">
                        <mat-option>Todos</mat-option>
                        <mat-option *ngFor="let s of consorcioList" [value]="s.Id">{{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}</mat-label>
                      <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                      <mat-select formControlName="ComunidadId" (selectionChange)="onDeudaFiltroUfComunidadSelect()">
                        <mat-option>Todos</mat-option>
                        <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionUf">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label *ngIf="!isUnidadesFuncionalesSearching">{{ 'UnidadFuncional' | translate}}</mat-label>
                      <mat-label *ngIf="isUnidadesFuncionalesSearching">Cargando...</mat-label>
                      <mat-select formControlName="UnidadFuncionalId">
                        <mat-option>Ninguna</mat-option>
                        <mat-option *ngFor="let s of ufList" [value]="s.Id">{{s.Codigo}}</mat-option>
                      </mat-select>
                    </mat-form-field>

                  </div>

                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <input type="text" placeholder="Proveedor" aria-label="Proveedor" matInput
                        [matAutocomplete]="proveedor" formControlName="Proveedor">
                      <i [ngStyle]="{'display': isProveedorAutoSearching ? 'inline-block' : 'none'}"
                        class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
                    </mat-form-field>
                    <mat-autocomplete #proveedor="matAutocomplete" [displayWith]="displayProveedor">
                      <mat-option *ngFor="let s of filteredProveedorList" [value]="s">
                        {{s.RazonSocial }}
                      </mat-option>
                    </mat-autocomplete>

                  </div>
                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Usuario</mat-label>
                      <input matInput formControlName="Usuario" (keyup.enter)="onSearch()">
                      <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                  </div>
                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Nro. Documento</mat-label>
                      <input matInput formControlName="NroDocumento" (keyup.enter)="onSearch()">
                      <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                  </div>

                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="MailContacto" (keyup.enter)="onSearch()">
                      <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                  </div>
                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Nro. Celular</mat-label>
                      <input matInput formControlName="MovilContacto" (keyup.enter)="onSearch()">
                      <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                  </div>
                  <div fxFlex=33 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 20px;"  *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">
                    <mat-checkbox formControlName="VerSoloAsociadosAUfs">
                      Ver solo {{'MovimientoDeuda' | translate}} de {{'UnidadFuncional' | translate}}
                    </mat-checkbox>
                  </div>

                </div>

                <div fxLayout="row stretch" fxLayout.xs="column">
                  <button mat-raised-button (click)="searchGastosPendientes()" [disabled]="isMovimientoDeudaSearching" color="primary" class="zb-button">
                    {{isMovimientoDeudaSearching ? 'Buscando...' : 'Buscar Deudas'}}
                  </button>
                </div>

              </form>

            </mat-expansion-panel>

          </div>

        </div>

        <!--GRILLA DE DEUDAS-->
        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

          <div fxFlex=100 fxFlex.xs=100 class="flex-item">

            <mat-expansion-panel [expanded]="true">

              <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;">

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label class="text-style"><b>Total Seleccionado</b>: {{monedaDeuda}} {{totalPorPagar | number: '1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

              </div>

              <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 10px;">

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                  <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isMovimientoDeudaSearching">
                    <mat-label class="text-style"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
                  </div>
                  <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isMovimientoDeudaSearching">

                    <ejs-grid #deudasPendientesGrid [dataSource]='deudasPendientesList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
                      [selectionSettings]='deudaSelectionOptions' [pageSettings]='pageSettings' [allowResizing]='true' (rowSelected)='onDeudaRowSelect($event)'
                      (rowDeselected)="onDeudaRowDeselected($event)" (dataBound)='onDeudaDataBound($event)' [contextMenuItems]='contextMenuItems' (contextMenuClick)='contextMenuClick($event)' (contextMenuOpen)='contextMenuOpen($event)'>
                      <e-columns>
                        <e-column type="checkbox" field="Seleccionado" width="40"></e-column>
                        <e-column field='FechaMovimiento' headerText='Fecha Movimiento' width=80 type='date' format="dd/MM/yyyy">
                          <ng-template #template let-data>
                            {{data.FechaMovimiento | date:'dd/MM/yyyy'}}
                          </ng-template>
                        </e-column>
                        <e-column field='FechaVencimiento' headerText='Vencimiento' width=80 type='date' format="dd/MM/yyyy">
                          <ng-template #template let-data>
                            {{data.FechaVencimiento | date:'dd/MM/yyyy'}}
                          </ng-template>
                        </e-column>
                        <e-column field='CuentaImputada' headerText='Referencia' width=90></e-column>
                        <e-column field='Detalle' headerText='Detalle' width=120></e-column>
                        <e-column field='TipoMovimientoNombre' headerText='Tipo' width=70></e-column>
                        <e-column field='Monto' headerText='Total' width=80 format="N2">
                          <ng-template #template let-data>
                            {{data.Moneda}} {{data.Monto | number:'1.2-2'}}
                          </ng-template>
                        </e-column>
                        <!-- <e-column field='AlicuotaIvaNombre' headerText='IVA' width=60></e-column> -->
                        <e-column field='Saldo' headerText='Pendiente' width=90 format="N2">
                          <ng-template #template let-data>
                            {{data.Moneda}} {{data.Saldo | number:'1.2-2'}}
                          </ng-template>
                        </e-column>
                        <e-column field='SaldoConvertido' headerText='Saldo Convertido' width=90 format="N2">
                          <ng-template #template let-data>
                            {{formGroup.controls['Moneda']?.value?.Codigo}} {{data.SaldoConvertido | number:'1.2-2'}}
                          </ng-template>
                        </e-column>
                      </e-columns>
                    </ejs-grid>

                  </div>

                </div>

              </div>

            </mat-expansion-panel>

          </div>

        </div>

      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

        <mat-expansion-panel-header>
          <mat-panel-title class="card-subtitulo">
            <mat-icon style="margin-top: -3px;">settings</mat-icon> Configuración de Financiación
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

          <mat-expansion-panel-header>
            <mat-panel-title class="card-subtitulo">
              Datos de Financiación
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="formGroup">

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%" >
                  <mat-label>Detalle*</mat-label>
                  <input matInput formControlName="Detalle" maxlength="100" (keyup.enter)="onGuardar()">
                  <mat-error *ngIf="!formGroup.controls['Detalle'].valid && formGroup.controls['Detalle'].touched">
                    {{ getErrorDetalle() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <!-- <mat-expansion-panel [expanded]="true" hideToggle="true"> -->
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label class="text-style">Observación</mat-label>
                    <textarea matInput formControlName="Observacion" maxlength="300"></textarea>
                    <mat-error *ngIf="!formGroup.controls['Observacion'].valid && formGroup.controls['Observacion'].touched">
                      {{ getErrorObservacion() }}
                    </mat-error>
                  </mat-form-field>
                <!-- </mat-expansion-panel> -->
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isAlicuotaIvaSearching">IVA*</mat-label>
                  <mat-label *ngIf="isAlicuotaIvaSearching">Cargando...</mat-label>
                  <mat-select formControlName="AlicuotaIvaId" (selectionChange)="onAlicuotaIvaSelect()">
                    <mat-option *ngFor="let s of alicuotaIvaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!formGroup.controls['AlicuotaIvaId'].valid && formGroup.controls['AlicuotaIvaId'].touched">
                    {{ getErrorAlicuotaIvaId() }}
                  </mat-error>
                </mat-form-field>
              </div>

            </div>

          </form>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

          <mat-expansion-panel-header>
            <mat-panel-title class="card-subtitulo">
              Datos de Formas de Pago
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin: 10px 0px;">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Total Financiación</b>: {{monedaDeuda}} {{totalPorPagar | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true" style="background-color: rgb(228, 186, 186);">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Pendiente</b>: {{monedaDeuda}} {{montoPendiente | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

          <form [formGroup]="financiacionFormGroup">

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin: 10px 0px;">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label *ngIf="!isTipoMovimientoSearching">Tipo de Movimiento*</mat-label>
                      <mat-label *ngIf="isTipoMovimientoSearching">Cargando...</mat-label>
                      <mat-select formControlName="TipoMovimientoId">
                          <mat-option *ngFor="let s of tipoMovimientoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="!financiacionFormGroup.controls['TipoMovimientoId'].valid && financiacionFormGroup.controls['TipoMovimientoId'].touched">
                          {{ getErrorTipoMovimientoId() }}
                      </mat-error>
                  </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Importe*</mat-label>
                      <input matInput type="number" formControlName="Importe" (change)="calcularMontos()" (keyup.enter)="onAccept()">
                      <mat-error *ngIf="!financiacionFormGroup.controls['Importe'].valid && financiacionFormGroup.controls['Importe'].touched">
                          {{ getErrorImporte() }}
                      </mat-error>
                  </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Cantidad de Cuotas*</mat-label>
                      <input matInput type="number" formControlName="CantidadCuotas" (change)="calcularMontos()" (keyup.enter)="onAccept()">
                      <mat-error *ngIf="!financiacionFormGroup.controls['CantidadCuotas'].valid && financiacionFormGroup.controls['CantidadCuotas'].touched">
                          {{ getErrorCantidadCuotas() }}
                      </mat-error>
                  </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%" >
                  <mat-label>{{(financiacionFormGroup?.controls['CantidadCuotas']?.value > 1) ? 'Fecha de Inicio de Cuota' : 'Fecha Movimiento'}}*</mat-label>
                  <input matInput [matDatepicker]="fechaInicioCuotaPicker" formControlName="FechaInicioCuota"  (click)="fechaInicioCuotaPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaInicioCuotaPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaInicioCuotaPicker></mat-datepicker>
                  <mat-error *ngIf="!financiacionFormGroup.controls['FechaInicioCuota'].valid && financiacionFormGroup.controls['FechaInicioCuota'].touched">
                    {{ getErrorFechaInicioCuota() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <ng-container *ngIf="(financiacionFormGroup?.controls['CantidadCuotas']?.value > 1)">

                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Periodicidad de Cuotas (en días)*</mat-label>
                      <input matInput type="number" formControlName="DiasRepeticionCuotas" (keyup.enter)="onAccept()">
                      <mat-error *ngIf="!financiacionFormGroup.controls['DiasRepeticionCuotas'].valid && financiacionFormGroup.controls['DiasRepeticionCuotas'].touched">
                        {{ getErrorDiasRepeticionCuotas() }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Porcentaje de Ajuste*</mat-label>
                      <input matInput type="number" formControlName="PorcentajeAjusteCuota" (change)="calcularMontos()" (keyup.enter)="onAccept()">
                      <mat-error *ngIf="!financiacionFormGroup.controls['PorcentajeAjusteCuota'].valid && financiacionFormGroup.controls['PorcentajeAjusteCuota'].touched">
                        {{ getErrorPorcentajeAjusteCuota() }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="(financiacionFormGroup?.controls['PorcentajeAjusteCuota']?.value > 0)">
                    <mat-checkbox class="text-style" formControlName="AplicarAjusteIncremental" (keyup.enter)="onAccept()" color="primary">
                      <mat-label style="white-space: normal !important;">Aplicar el porcentaje de ajuste de forma incremental en cada cuota</mat-label>
                    </mat-checkbox>
                  </div>

              </ng-container>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-style"><b>Importe Primera Cuota</b>: {{data?.Moneda}} {{montoCuota | number:'1.2-2'}}</mat-label>
                      </div>
                  </mat-expansion-panel>
              </div>

            </div>

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin: 5px 0px;">
              <button mat-raised-button color="primary" (click)="onSave()" class="zb-button">Guardar Movimiento</button>
              <button mat-raised-button color="warn" (click)="onClean()" class="zb-button">Limpiar</button>
            </div>

            <hr width="100%" style="margin: 10px 0px;">

            <div fxLayout="row stretch" fxLayout.xs="column">

              <ejs-grid #grid [dataSource]='movimientoList' [allowPaging]="false" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
                [pageSettings]='pageSettings' [allowResizing]='true' >
                <e-columns>
                  <e-column field='FechaInicioCuota' headerText='Fecha' width=80 type="date" format="dd/MM/yyyy"></e-column>
                  <e-column field='TipoMovimiento' headerText='Tipo' width=90></e-column>
                  <e-column field='Importe' headerText='Importe' width=70 format="N2"></e-column>
                  <e-column field='CantidadCuotas' headerText='Cuotas' width=60></e-column>
                  <e-column field='DiasRepeticionCuotas' headerText='Periodicidad' width=50></e-column>
                  <e-column field='PorcentajeAjusteCuota' headerText='Ajuste' textAlign="right" width=50>
                    <ng-template #template let-data>
                      {{data.PorcentajeAjusteCuota | number:'1.2-2'}}%
                    </ng-template>
                  </e-column>
                  <e-column field='AplicarAjusteIncremental' headerText='Incremental?' width=50>
                    <ng-template #template let-data>
                      {{data.AplicarAjusteIncremental ? 'Sí' : 'No'}}
                    </ng-template>
                  </e-column>
                  <e-column headerText='Acciones' width=60 textAlign='Center'>
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 5px" (click)="onEdit(data)" title="Editar movimiento">
                        <i class="fa fa-pencil fa-1x"></i>
                      </a>
                      <a style="cursor: pointer; margin-right: 5px" (click)="onDelete(data)" title="Eliminar movimiento">
                        <i class="fa fa-trash fa-1x"></i>
                      </a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>

            </div>

          </form>

        </mat-expansion-panel>

      </mat-expansion-panel>

    </ng-container>

  </mat-card-content>

  <mat-card-actions>
    <div class="flex-actions">
      <button mat-raised-button (click)="onGuardar()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary" class="zb-button">
        {{isSaving ? 'Guardando...' : 'Guardar Financiación'}}
      </button>
      <button mat-raised-button (click)="onCancel()" color="warn">Cerrar</button>
    </div>
  </mat-card-actions>

</mat-card>
